/** Runtime configuration sourced from Vite env vars (parity with legacy `@genai/config`). */
export const config = {
  apiBase: import.meta.env.VITE_API_BASE ?? "/api",
  enableOktaAuth: import.meta.env.OKTA_ENABLE_AUTH !== "false",
  oktaIssuer: import.meta.env.OKTA_ISSUER ?? "",
  oktaClientId: import.meta.env.OKTA_CLIENT_ID ?? "",
  redirectUrl: import.meta.env.OKTA_REDIRECT_URL ?? "",
};

export default config;
